import sideSwitcher from './controls/sideSwitcher';
import layersControl from './controls/layersControl';
import controlBox from './controls/controlBox';

export default {
    template: '#left_control',
    props: ['designerItems', 'currentSide', 'selectedProduct'],
    methods: {
        isSublimationProduct: function () {
            return this.$root.isSublimationProduct();
        }
    },
    components: {
        'side-switch-control': sideSwitcher,
        'layers-control': layersControl,
        'control-box': controlBox
    }
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/designer_tab/leftControl.js